<template>
  <div>
    <container-headline
      :headline="$t('global.otherimportantinformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <!--<div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="firma.hofangaben.versicherungen"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.insurances") }}</label>
              </div>
            </div>
          </div>-->
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="firma.hofangaben.verbandsmitgliedschaft"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.membershipfarmersassociation") }}</label>
              </div>
            </div>
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="firma.hofangaben.vereinsmitgliedAgriviva"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.memberofagriviva") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "FirmaWeitereAngabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    firma: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
